/*

jvHideOnBlur
============

Hide an element when it loses focus.

Usage
-----
<span ng-show="visible" jv-hide-on-blur="visible = false">...</span>

 */

angular.module('jv.Common.Directives.HideOnBlur', [])

.directive('jvHideOnBlur', ['$document', '$timeout', function ($document, $timeout) {

	var els = [];

	const clickHandler = function(e) {
		angular.forEach(els, function(item) {
			if (item.visible && !angular.element(e.target).closest(item.el)[0]) {
				item.hide();
			}
		});
	};
	if (parseFloat(jQuery.fn.jquery) <= 1.3) {
		$document.click(clickHandler);
	} else {
		$document.on('click', clickHandler);
	}

	return {
		link: function (scope, elm, attrs) {
			var item = {
				el: elm,
				hide: function() {
					scope.$apply(function() {
						scope.$eval(attrs.jvHideOnBlur);
					});
				},
				visible: false
			};
			els.push(item);

			scope.$watch(attrs.ngShow, function(visible) {
				$timeout(function() {
					item.visible = visible;
				});
			});
		}
	};
}]);